import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { CustomerDetailsForVehicleViewModel } from '../../../business-entities/Customer-detail.model';
import { DFModel } from '../../../business-entities/df-model';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { BrandType, ModelType, OwnerType, VehicleTransmission, VehicleType } from '../../../business-entities/vehicle-list-view-model';
import {
  ApproveRejectAppointmentModal,
  EditWidgetVehicleDetail,
  ResponseModal
} from '../../../business-entities/widget-appointment-request-model';
import { BrandService } from '../../../business-services/brand.service';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { WidgetAppointmentService } from '../../../business-services/widget-appointment.service';
import { CustomerValidationComponent } from '../customer-validation/customer-validation.component';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { SettingService } from '../../../business-services/setting.service';
import { AppointmentService } from '../../../business-services/appointment.service';
import { AppointmentList } from '../../../business-entities/appointmentList-model';
@Component({
  selector: 'app-edit-widget-appointment',
  templateUrl: './edit-widget-appointment.component.html',
  styleUrls: ['./edit-widget-appointment.component.css'],
})
export class EditWidgetAppointmentComponent implements OnInit {
  selectedTab: number = 1;
  appointmentDetails: any;
  licensePlateClass: string;
  dropdownSettings = {};
  ownerTypeList: Array<SelectListItemViewModel>;
  widgetOwnerTypeList: Array<SelectListItemViewModel>;
  DFOwnerTypeList: Array<SelectListItemViewModel>;
  selectedWidgetItems = [];
  selectedDFItems = [];
  approverejectModal: ApproveRejectAppointmentModal = {
    widgetAppointmentId: null,
    isApprove: null,
    existingVehicleId: null,
    customerID: null,
    customerNumber: '',
    customerPayerId: null,
    customerOwnerId: null,
    customerUserId: null,
    customerDriverId: null,
    userId: '',
    integrationWithDMS: false,
    moduleId: null,
    languageCode: '',
    generateWorkOrderNoPlannerSide: false,
    appointmentModuleId: null,
    appointmentType: "",
    ownerTypeId:'',
    ownerType:'',
    vin:'',
    customerNoDriver:null,
    customerNoOwner:null,
    customerNoPayer:null,
    customerNoUser:null,
    realtimeDmsSyncAppointment:true,
    realtimeDmsSyncVehicle:true,
    realtimeDmsSyncWidgetAppointmentRequest:true,
    isRentalCarRequired : false,
    licensePlate:"",
    customerEmail:""
  };
  customerDetails: CustomerDetailsForVehicleViewModel;
  customerOwner: any;
  customerPayer: any;
  customerUser: any;
  customerDriver: any;
  emptyRecord = [];
  activePanel = ['first', 'second', 'third','fourth'];
  widgetAppointmentDetails: ResponseModal;
  widgetData: any[];
  features: Features[] = [];
  dataFactoryData: any[];
  widgetValidated: boolean = true;
  AddModeltoMaster: boolean = false;
  dataFactoryValidated: boolean = false;
  IsRentalCarActive:boolean;
  isOfferActive:boolean = false;
  vehicleId: number;
  isWidgetCopyToDisable = true;
  isDFCopyToDisable = true;
  popupCloseResult = false;
  selectedOwnerType:any[]=[];
  validatedWidgetCustomerDetails:any;
  activeAppointmentList: AppointmentList[] = []; 
  SelectedVehicleId: any = null;
  SelectedCustomerId: any = null; 
  validatedDFCustomerDetails:any;
  isVehicleDetailEditable:boolean=false;
  makeList: BrandType[] = [];
  vehicleTypes: VehicleType[] = [];
  fuels: FuelType[] = [];
  modelList: ModelType[] = [];
  vehicleTransmissionList: VehicleTransmission[] = [];
  isEdit:boolean=false;
  showPickDropService: boolean = false;
  deafultDialCode: string;
  onlyCountries: string[] = [];
  countryDialCodes: any[] = [];
  isInitialLoad: boolean = true;
  CountryISO = CountryISO;
  selectedCountryISO = this.cultureLocaleService.getLocale() || CountryISO.Norway;
  
  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly service: WidgetAppointmentService,
    private readonly activeModal: NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly cookieservice: CookieService,
    private readonly translate: TranslateService,
    private readonly toaster: ToastrService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly vehicleBusinessService: VehicleBusinessService,
    private readonly globalSetting: GlobalSetting,
    private readonly secureStorage: SecureStorage,
    private readonly VehicleService: VehicleBusinessService,
    private readonly brandService: BrandService,
    private readonly checkListService: CheckListBusinessService,
    private readonly EditRentalCar: RentalCarService,
    private readonly cdr: ChangeDetectorRef,
    private readonly multiStackPopupService: MultiStackPopupService,
    private readonly router: Router,
    private readonly clipboardApi: ClipboardService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      itemsShowLimit: 3,
      enableCheckAll: false,
      allowSearchFilter: false,
      searchPlaceholderText: 'Search here',
      maxHeight: 150,
      autoPosition: false,
    };

    this.appointmentDetails = this.service.widgetAppointment;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.vehicleId = this.appointmentDetails.existingVehicleId;
    this.SelectedCustomerId = this.appointmentDetails.existingCustomerId;
    this.emptyRecord = [
      {
        address1: '',
        address2: '',
        city: '',
        country: '',
        customerId: null,
        customerName: '',
        customerNo: '',
        dialCode: '',
        dob: '',
        email: '',
        firstName: '',
        isCompany: null,
        lastName: '',
        mobileNo: '',
        ownerType: '',
        ownerTypeId: null,
        phoneNumber: '',
        phoneNumberCode: '',
        postCode: '',
        vehicleId: null,
        vehicleRelation: '',
        isCopyFromWidget: false,
        isCopyFromDF: false,
      },
    ];

    if (this.vehicleId == null) {
      this.forNewCar();
    } else {
      this.getCustomerDetail(this.vehicleId);
    }
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.GetAllOwnerType();
    this.getWidgetAppointmentDetail(this.appointmentDetails.id);
    if(this.vehicleId > 0){
      this.getActiveAppointmentList();
    }
    this.currentLanguageService.featureList.subscribe(res => {
      this.features = res;
      if (this.features && this.features.length > 0) {
        this.showPickDropService = this.features.find(x => x.featureCode === Enums.FeatureCode.PickupDropoff)?.isActive;
        this.IsRentalCarActive = this.features.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive;
        this.isOfferActive = this.features.find(x => x.featureCode === Enums.FeatureCode.OFFER)?.isActive;
      }
    });
  }

  async GetAllOwnerType(): Promise<void> {
    await this.vehicleBusinessService
      .GetVehicleOwnerTypeDropdownList()
      .then((data) => {
        this.ownerTypeList = this.mapdealer(data.responseObject);
      });
  }

  mapdealer(array: OwnerType[]) {
    let supperArray = [];
   if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.value = element.rowId;
        single.text = element.ownerType;

        supperArray.push(single);
      })
    }
    this.widgetOwnerTypeList = supperArray;
    this.DFOwnerTypeList = supperArray;
    return supperArray;
  }

  IsEdit(){
    this.isEdit = false;
    this.isVehicleDetailEditable = true;
  }

  OnCancleVehicleEdit(){
    this.isEdit = true;
    this.isVehicleDetailEditable = false;
    this.getWidgetAppointmentDetail(this.appointmentDetails.id);
  }

  async getCustomerDetail(vehicleId: any): Promise<void> {
    this.spinner.show();
    await this.vehicleBusinessService
      .getCustomerDetailByVehicleId(vehicleId)
      .then((response) => {
        if (response.responseCode === Constant.SuccessResponseCode) {
          this.customerDetails = response.responseObject;
          this.setCustomerData();
        } else if (
          response.responseObject &&
          response.responseObject.errorCount > 0
        ) {
          if (
            response.responseObject.result &&
            response.responseObject.result.errorCode ===
            Enums.ErrorCodes.ServicecategoriesNotFound
          ) {
            let ErrorMsg = this.translate.instant('lblCustomerDetailNotFound');
            this.toaster.error(ErrorMsg);
          }
        }
        this.spinner.hide();
      });
  }

  getActiveAppointmentList() {
    this.spinner.show();
    this.appointmentService.getActiveAppointment(this.vehicleId, this.SelectedCustomerId, this.cookieservice.get('userSelectedLanguage')).then((res) => {
      if (res && res.length > 0) {
        this.activeAppointmentList = this.mapActiveAppointment(res);
        if (this.activeAppointmentList && this.activeAppointmentList?.length > 0) {
          this.spinner.hide(); 
        } 
      }
      else {
        this.spinner.hide(); 
      }
    }).catch(_err => {
      this.spinner.hide();
    })
  }

  private mapActiveAppointment(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = index + 1;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
        single.bookedDateTime = element.bookedDateTime;
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        single.sourceCreation = element.sourceCreation;
        single.unitPrice = element.unitPrice;
        single.chassisNo = element.chassisNo;
        supperArray.push(single);
      }
    }
    return supperArray;
  } 

  async getWidgetAppointmentDetail(id) {
    this.spinner.show();
    let languageCode = this.cookieservice.get('userSelectedLanguage');
    await this.service
      .getWidgetAppointmentDetail(id, languageCode)
      .then((response) => {
        this.widgetAppointmentDetails = response.responseObject;
        this.widgetAppointmentDetails.selectedDate = (this.widgetAppointmentDetails.selectedDate)?Utility.ConvertUTCDateToLocalDate(this.widgetAppointmentDetails.selectedDate):null
        this.widgetAppointmentDetails.startTime = (this.widgetAppointmentDetails.startTime)? Utility.ConvertUTCDateToLocalTime(this.widgetAppointmentDetails.startTime):null
        this.widgetAppointmentDetails.endTime = (this.widgetAppointmentDetails.endTime)?Utility.ConvertUTCDateToLocalTime(this.widgetAppointmentDetails.endTime):null
        this.isEdit = (this.widgetAppointmentDetails.vehicleSource === Constant.AddedManualByCustomer) ? true:false;
        if(this.widgetAppointmentDetails?.list && this.widgetAppointmentDetails?.list?.length>0){
          this.widgetAppointmentDetails?.list?.forEach(element => {
            element.selectedDate = (element.selectedDate)?Utility.ConvertUTCDateToLocalDate(element.selectedDate):null
            element.startTime = (element.startTime)?Utility.ConvertUTCDateToLocalTime(element.startTime):null
            element.endTime = (element.endTime)?Utility.ConvertUTCDateToLocalTime(element.endTime):null
          });
        }
        if(this.isEdit)
        {
          this.GetAllDropDownDetails();
        }
        this.widgetData = this.WidgetDataMapper(response.responseObject, true);
        this.dataFactoryData = this.WidgetDataMapper(
          response.responseObject,
          false
        );
        this.spinner.hide();
      },_error =>{
        this.spinner.hide();
      });
  }

  async GetAllDropDownDetails()
  {
    await this.GetAllMake();
    await this.GetAllModel(this.widgetAppointmentDetails.vehicle_BrandName)
    await this.GetAllVehicleTypes();
    await this.GetAllFuelTypes();
    await this.GetVehicleTransmission()
  }

  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    });
  }

  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuels = data.responseObject.result.slice();
    });
  }

  async GetVehicleTransmission(): Promise<void> {
    await this.VehicleService.GetVehicleTransmissionDropdownList().then(data => {
      this.vehicleTransmissionList = data.responseObject;
    });
  }

  async onMakeSelected(make: string) {
    this.widgetAppointmentDetails.vehicle_BrandName=this.makeList.filter(x=>x.brandCode===make)[0]?.brandName;
    if (make?.trim()) {
      this.GetAllModel(make);
    } else {
      this.modelList = [];
    }
    this.widgetAppointmentDetails.vehicle_Model = null;
    this.cdr.detectChanges();
  }

  async GetAllModel(make: string): Promise<void> {
    await this.brandService.GetModelnoDropdownList(make).then(data => {
      this.modelList = data.responseObject;
    });
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async editVehicleDetail()
  {
    if(this.widgetAppointmentDetails.vehicle_Model && this.widgetAppointmentDetails.vehicle_BrandName && this.widgetAppointmentDetails.vehicle_Brand
      && this.widgetAppointmentDetails.vehicle_ChassisNo &&  this.widgetAppointmentDetails.vehicle_Transmission &&
      this.widgetAppointmentDetails.vehicle_Year && this.widgetAppointmentDetails.vehicle_Color && this.widgetAppointmentDetails.vehicle_VehicleType
      && this.widgetAppointmentDetails.vehicle_FuelType)
    {
      if(this.widgetAppointmentDetails.vehicle_Year > new Date().getFullYear())
      {
        let error = this.translate.instant("lblProvideValidYear");
          this.toaster.error(error);
          return;
      }

      let editVehicleDetail: EditWidgetVehicleDetail =
      {
        vehicleModel: this.widgetAppointmentDetails.vehicle_Model,
        vehicleBrandName: this.widgetAppointmentDetails.vehicle_BrandName,
        vehicleBrandCode: this.widgetAppointmentDetails.vehicle_Brand,
        chassisNumber: this.widgetAppointmentDetails.vehicle_ChassisNo,
        transmission: this.widgetAppointmentDetails.vehicle_Transmission,
        mileage: this.widgetAppointmentDetails.vehicle_Mileage,
        year: this.widgetAppointmentDetails.vehicle_Year,
        color: this.widgetAppointmentDetails.vehicle_Color,
        vehicleType: this.widgetAppointmentDetails.vehicle_VehicleType,
        fuelType: this.widgetAppointmentDetails.vehicle_FuelType,
        id:this.widgetAppointmentDetails.id
      }
      await this.service.updateWidgetAppointmentVehicleDetail(editVehicleDetail)
      .then((response) => {
        if(response.responseObject && response.responseObject?.errorCount===1)
        {
          let error = this.translate.instant("lblInvalidParameter");
          this.toaster.error(error);
        }
        else if(response.responseObject && response.responseObject===true)
        {
          let success = this.translate.instant("lblVehicleDetailsUpdated");
          this.toaster.success(success);
          this.isVehicleDetailEditable = false;
          this.isEdit = true;
        }
        else
        {
          let error = this.translate.instant("lblFailedToUpdateVehicleDetails");
          this.toaster.error(error);
        }
      });
    }
    else
    {
      let error = this.translate.instant("lblInvalidDetailsProvideMandatoryValue");
      this.toaster.error(error);
    }

  }

  private WidgetDataMapper(List: any, isCust: boolean) {
    let supperArray = [];

    if (List) {
      let single = Object();
      if (isCust) {
        single.customerName = List.cust_Name;
        single.firstName = List.cust_FirstName;
        single.lastName = List.cust_LastName;
        single.mobileNo = List.cust_MobileNo;
        single.cust_ContactNo = List.cust_MobileNo;
        this.selectedCountryISO = this.getCountryCodeByDialCode(List.cust_DialCode);
        single.email = List.cust_Email;
        single.address1 = List.cust_Address1;
        single.address2 = List.cust_Address2;
        single.city = List.cust_City;
        single.country = List.cust_Country;
        single.postCode = List.cust_Pincode;
        single.vehicleRelation = List.cust_OwnerTyper;
        single.customerNo = '';
        single.customerId = null;
        single.userConsent = List.userConsent;
        single.dialCode = List.cust_DialCode;
        single.cust_DialCountryCode = List.cust_DialCountryCode;
        single.countryCode = List.countryCode
      } else {
        single.customerName = List.dF_Name;
        single.firstName = List.dF_FirstName;
        single.lastName = List.dF_LastName;
        if(List.dF_DialCode && List.dF_DialCode[0]==="+")
        single.cust_ContactNo= List.dF_DialCode?List.dF_DialCode+List.dF_MobileNo :List.dF_MobileNo;
      else
      single.cust_ContactNo= List.dF_DialCode?"+"+List.dF_DialCode+List.dF_MobileNo :List.dF_MobileNo;
        single.mobileNo = List.dF_MobileNo;
        single.email = List.dF_Email;
        single.address1 = List.dF_Address1;
        single.address2 = List.dF_Address2;
        single.city = List.dF_City;
        single.country = List.dF_Country;
        single.postCode = List.dF_Pincode;
        single.vehicleRelation = List.dF_OwnerTyper;
        single.customerNo = '';
        single.customerId = null;
        single.dialCode = List.dF_DialCode;
        single.countryCode = List.dfCountryCode
      }
      supperArray.push(single);
    }
    return supperArray;
  }

  setCustomerData() {
    this.customerPayer =this.updateCustomerDetails(this.customerDetails.customerPayer, 'lblPayer');
    this.customerOwner = this.updateCustomerDetails(this.customerDetails.customerOwner, 'lblOwner');
    this.customerUser = this.updateCustomerDetails(this.customerDetails.customerUser, 'lblUser');
    this.customerDriver = this.updateCustomerDetails(this.customerDetails.customerDriver, 'lblDriver');
  }
  updateCustomerDetails(customer, relationLabel) {
    if (customer != null) {
      customer.mobileNo = customer.mobileNo ? customer.mobileNo.replace('+', '') : '';
      customer.vehicleRelation = this.translate.instant(relationLabel);
      customer.isCopyFromWidget = false;
      customer.isCopyFromDF = false;
      return customer;
    } else {
      return this.emptyRecord[0];
    }
  }
  forNewCar() {
    let customer: CustomerDetailsForVehicleViewModel = {
      customerPayer: undefined,
      customerOwner: undefined,
      customerUser: undefined,
      customerDriver: undefined,
    };

    this.customerOwner = this.emptyRecord[0];
    this.customerPayer = this.emptyRecord[0];
    this.customerUser = this.emptyRecord[0];
    this.customerDriver = this.emptyRecord[0];
    Object.assign(customer, {
      customerOwner: this.customerOwner,
      customerPayer: this.customerPayer,
      customerUser: this.customerUser,
      customerDriver: this.customerDriver,
    });
    this.customerDetails = customer;
  }
  MapValidatedDetails(fromWidget:boolean,type:string){
    if(fromWidget){
      if(type == 'owner'){
        this.customerOwner.city = this.validatedWidgetCustomerDetails?.city;
        this.customerOwner.country = this.validatedWidgetCustomerDetails?.country;
        this.customerOwner.customerName = this.validatedWidgetCustomerDetails?.customerName;
        this.customerOwner.postCode = this.validatedWidgetCustomerDetails?.pincode;
        this.customerOwner.email = this.validatedWidgetCustomerDetails?.email;
        this.customerOwner.mobileNo = this.validatedWidgetCustomerDetails?.mobileNo;
        this.customerOwner.address1 = (this.validatedWidgetCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[0];
        this.customerOwner.address2 = (this.validatedWidgetCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'payer'){
        this.customerPayer.city = this.validatedWidgetCustomerDetails?.city;
        this.customerPayer.country = this.validatedWidgetCustomerDetails?.country;
        this.customerPayer.customerName = this.validatedWidgetCustomerDetails?.customerName;
        this.customerPayer.postCode = this.validatedWidgetCustomerDetails?.pincode;
        this.customerPayer.email = this.validatedWidgetCustomerDetails?.email;
        this.customerPayer.mobileNo = this.validatedWidgetCustomerDetails?.mobileNo;
        this.customerPayer.address1 = (this.validatedWidgetCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[0];
        this.customerPayer.address2 = (this.validatedWidgetCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'user'){
        this.customerUser.city = this.validatedWidgetCustomerDetails?.city;
        this.customerUser.country = this.validatedWidgetCustomerDetails?.country;
        this.customerUser.customerName = this.validatedWidgetCustomerDetails?.customerName;
        this.customerUser.postCode = this.validatedWidgetCustomerDetails?.pincode;
        this.customerUser.email = this.validatedWidgetCustomerDetails?.email;
        this.customerUser.mobileNo = this.validatedWidgetCustomerDetails?.mobileNo;
        this.customerUser.address1 = (this.validatedWidgetCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[0];
        this.customerUser.address2 = (this.validatedWidgetCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'driver'){
        this.customerDriver.city = this.validatedWidgetCustomerDetails?.city;
        this.customerDriver.country = this.validatedWidgetCustomerDetails?.country;
        this.customerDriver.customerName = this.validatedWidgetCustomerDetails?.customerName;
        this.customerDriver.postCode = this.validatedWidgetCustomerDetails?.pincode;
        this.customerDriver.email = this.validatedWidgetCustomerDetails?.email;
        this.customerDriver.mobileNo = this.validatedWidgetCustomerDetails?.mobileNo;
        this.customerDriver.address1 = (this.validatedWidgetCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[0];
        this.customerDriver.address2 = (this.validatedWidgetCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedWidgetCustomerDetails?.address.split(",")[1];
      }
    }
    else{
      if(type == 'owner'){
        this.customerOwner.city = this.validatedDFCustomerDetails?.city;
        this.customerOwner.country = this.validatedDFCustomerDetails?.country;
        this.customerOwner.customerName = this.validatedDFCustomerDetails?.customerName;
        this.customerOwner.postCode = this.validatedDFCustomerDetails?.pincode;
        this.customerOwner.email = this.validatedDFCustomerDetails?.email;
        this.customerOwner.mobileNo = this.validatedDFCustomerDetails?.mobileNo;
        this.customerOwner.address1 = (this.validatedDFCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[0];
        this.customerOwner.address2 = (this.validatedDFCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'payer'){
        this.customerPayer.city = this.validatedDFCustomerDetails?.city;
        this.customerPayer.country = this.validatedDFCustomerDetails?.country;
        this.customerPayer.customerName = this.validatedDFCustomerDetails?.customerName;
        this.customerPayer.postCode = this.validatedDFCustomerDetails?.pincode;
        this.customerPayer.email = this.validatedDFCustomerDetails?.email;
        this.customerPayer.mobileNo = this.validatedDFCustomerDetails?.mobileNo;
        this.customerPayer.address1 = (this.validatedDFCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[0];
        this.customerPayer.address2 = (this.validatedDFCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'user'){
        this.customerUser.city = this.validatedDFCustomerDetails?.city;
        this.customerUser.country = this.validatedDFCustomerDetails?.country;
        this.customerUser.customerName = this.validatedDFCustomerDetails?.customerName;
        this.customerUser.postCode = this.validatedDFCustomerDetails?.pincode;
        this.customerUser.email = this.validatedDFCustomerDetails?.email;
        this.customerUser.mobileNo = this.validatedDFCustomerDetails?.mobileNo;
        this.customerUser.address1 = (this.validatedDFCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[0];
        this.customerUser.address2 = (this.validatedDFCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[1];
      }
      else if(type == 'driver'){
        this.customerDriver.city = this.validatedDFCustomerDetails?.city;
        this.customerDriver.country = this.validatedDFCustomerDetails?.country;
        this.customerDriver.customerName = this.validatedDFCustomerDetails?.customerName;
        this.customerDriver.postCode = this.validatedDFCustomerDetails?.pincode;
        this.customerDriver.email = this.validatedDFCustomerDetails?.email;
        this.customerDriver.mobileNo = this.validatedDFCustomerDetails?.mobileNo;
        this.customerDriver.address1 = (this.validatedDFCustomerDetails?.address.split(",")[0]== undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[0];
        this.customerDriver.address2 = (this.validatedDFCustomerDetails?.address.split(",")[1] == undefined)?'':this.validatedDFCustomerDetails?.address.split(",")[1];
      }
    }
  }
  copyData(item: any, data: any, fromWidget: boolean) {
    if (fromWidget) {
      this.DFOwnerTypeList = this.DFOwnerTypeList.filter(
        (obj) => obj.value !== item.value
      );
      this.selectedOwnerType.push(item);
    } else {
      this.widgetOwnerTypeList = this.widgetOwnerTypeList.filter(
        (obj) => obj.value !== item.value
      );
    }
    switch (item.value) {
      case 1:
        if (fromWidget) {
          this.approverejectModal.customerOwnerId =
            this.widgetData[0].customerId;
             this.approverejectModal.customerNoOwner=this.widgetData[0].customerNo
          data.isCopyFromWidget = true;
        } else {
          data.isCopyFromDF = true;
          this.approverejectModal.customerOwnerId =
            this.dataFactoryData[0].customerId;
             this.approverejectModal.customerNoOwner=this.dataFactoryData[0].customerNo;
        }
        this.customerOwner = JSON.parse(JSON.stringify(data));
        this.customerOwner.vehicleRelation = this.translate.instant('lblOwner');
        this.MapValidatedDetails(fromWidget,'owner');
        break;
      case 7:
        if (fromWidget) {
          this.approverejectModal.customerPayerId =
            this.widgetData[0].customerId;
          data.isCopyFromWidget = true;
           this.approverejectModal.customerNoPayer =this.widgetData[0].customerNo;
        } else {
          this.approverejectModal.customerPayerId =
            this.dataFactoryData[0].customerId;
          data.isCopyFromDF = true;
           this.approverejectModal.customerNoPayer =this.dataFactoryData[0].customerNo;
        }
        this.customerPayer = JSON.parse(JSON.stringify(data));
        this.customerPayer.vehicleRelation = this.translate.instant('lblPayer');
        this.MapValidatedDetails(fromWidget,'payer');
        break;
      case 8:
        if (fromWidget) {
          this.approverejectModal.customerUserId =
            this.widgetData[0].customerId;
          data.isCopyFromWidget = true;
          this.approverejectModal.customerNoUser =this.widgetData[0].customerNo;
        } else {
          this.approverejectModal.customerUserId =
            this.dataFactoryData[0].customerId;
          this.approverejectModal.customerNoUser=this.dataFactoryData[0].customerNo;
          data.isCopyFromDF = true;
        }
        this.customerUser = JSON.parse(JSON.stringify(data));
        this.customerUser.vehicleRelation = this.translate.instant('lblUser');
        this.MapValidatedDetails(fromWidget,'user');
        break;
      case 9:
        if (fromWidget) {
          this.approverejectModal.customerDriverId =
            this.widgetData[0].customerId;
            this.approverejectModal.customerNoDriver =this.widgetData[0].customerNo;
          data.isCopyFromWidget = true;
        } else {
          this.approverejectModal.customerDriverId =
            this.dataFactoryData[0].customerId;
            this.approverejectModal.customerNoDriver=this.dataFactoryData[0].customerNo;
          data.isCopyFromDF = true;
        }
        this.customerDriver = JSON.parse(JSON.stringify(data));
        this.customerDriver.vehicleRelation = this.translate.instant('lblDriver');
        this.MapValidatedDetails(fromWidget,'driver');
        break;

      default:
        break;
    }
  }

  onResetClick() {
    this.selectedWidgetItems = [];
    this.selectedDFItems = [];
    this.selectedOwnerType=[];
    this.approverejectModal.customerOwnerId = null;
    this.approverejectModal.customerPayerId = null;
    this.approverejectModal.customerUserId = null;
    this.approverejectModal.customerDriverId = null;
    this.approverejectModal.customerNoOwner=null;
    this.approverejectModal.customerNoPayer=null;
    this.approverejectModal.customerNoUser=null;
    this.approverejectModal.customerNoDriver=null;
    this.onResetCopy();
  }

  onResetCopy() {
    this.DFOwnerTypeList = this.ownerTypeList;
    this.widgetOwnerTypeList = this.ownerTypeList;
    if (this.vehicleId == null) {
      this.forNewCar();
    } else {
      if (this.customerDetails) {
        this.setCustomerData();
      }
    }
  }

  onWidgetItemSelect(event: any) {
    if(event.value === 9 && this.validatedWidgetCustomerDetails.customerType==="Company")
    {
      this.selectedWidgetItems=this.selectedWidgetItems.filter(x=> x.value!==event.value)
      let errorMsg = this.translate.instant('lblDriverCannotBeCompany');
      this.toaster.error(errorMsg);
      return;
    }
    this.copyData(event, this.widgetData[0], true);
  }

  onDFItemSelect(event: any) {
    if(event.value === 9 && this.validatedDFCustomerDetails.customerType==="Company")
    {
      this.selectedDFItems=this.selectedDFItems.filter(x=> x.value!==event.value)
      let errorMsg = this.translate.instant('lblDriverCannotBeCompany');
      this.toaster.error(errorMsg);
      return;
    }
    this.copyData(event, this.dataFactoryData[0], false);
  }

  onWidgetDeSelect(event: any) {
    if (event == null || event.length == 0) {
      this.selectedWidgetItems = [];
    } else {
      this.removeCopyData(event, true);
    }
  }

  onDFDeSelect(event: any) {
    if (event == null || event.length == 0) {
      this.selectedDFItems = [];
    } else {
      this.removeCopyData(event, false);
    }
  }

  removeCopyData(item: any, fromWidget: boolean) {
    if (fromWidget) {
      if (this.selectedWidgetItems.length > 0) {
        this.DFOwnerTypeList = this.ownerTypeList.filter((object1) => {
          return !this.selectedWidgetItems.some((object2) => {
            return object1.value === object2.value;
          });
        });
      } else {
        this.DFOwnerTypeList = this.ownerTypeList;
      }
      this.selectedOwnerType=this.selectedOwnerType.filter(i=>i.value !== item.value);
    } else {
      this.widgetOwnerTypeList = this.widgetOwnerTypeList.filter(
        (obj) => obj.value !== item.value
      );
      if (this.selectedDFItems.length > 0) {
        this.widgetOwnerTypeList = this.ownerTypeList.filter((object1) => {
          return !this.selectedDFItems.some((object2) => {
            return object1.value === object2.value;
          });
        });
      } else {
        this.widgetOwnerTypeList = this.ownerTypeList;
      }
    }

    switch (item.value) {
      case 1:
        this.approverejectModal.customerOwnerId = null;
        this.approverejectModal.customerNoOwner=null;
        if (this.customerDetails.customerOwner != null) {
          this.customerDetails.customerOwner.isCopyFromWidget = false;
          this.customerDetails.customerOwner.isCopyFromDF = false;
          this.customerOwner = this.customerDetails.customerOwner;
        } else {
          this.customerOwner = this.emptyRecord[0];
        }
        break;
      case 7:
        this.approverejectModal.customerPayerId = null;
        this.approverejectModal.customerNoPayer=null;
        if (this.customerDetails.customerPayer != null) {
          this.customerDetails.customerPayer.isCopyFromWidget = false;
          this.customerDetails.customerPayer.isCopyFromDF = false;
          this.customerPayer = this.customerDetails.customerPayer;
        } else {
          this.customerPayer = this.emptyRecord[0];
        }
        break;
      case 8:
        this.approverejectModal.customerUserId = null;
        this.approverejectModal.customerNoUser=null;
        if (this.customerDetails.customerUser != null) {
          this.customerDetails.customerUser.isCopyFromWidget = false;
          this.customerDetails.customerUser.isCopyFromDF = false;
          this.customerUser = this.customerDetails.customerUser;
        } else {
          this.customerUser = this.emptyRecord[0];
        }
        break;
      case 9:
        this.approverejectModal.customerDriverId = null;
        this.approverejectModal.customerNoDriver=null;
        if (this.customerDetails.customerDriver != null) {
          this.customerDetails.customerDriver.isCopyFromWidget = false;
          this.customerDetails.customerDriver.isCopyFromDF = false;
          this.customerDriver = this.customerDetails.customerDriver;
        } else {
          this.customerDriver = this.emptyRecord[0];
        }
        break;

      default:
        break;
    }
  }
  
  GetDFInformation() {
    let modelBodymsg = this.translate.instant('lblSureToSearchDF');
    let modelHeadermsg = this.translate.instant('lblDFSearch');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      _result => { 
        // This is intentional
      },
      reason => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.DFSearch(this.appointmentDetails.licensePlate);
        }
      }
    );
  }
  async DFSearch(vehicleNo: string) {
    this.spinner.show();
    let noVehicleFound = this.translate.instant("lblDFVehicleNotFound");
    await this.VehicleService.getVehicleFrmoDataFactoryByLicencePlateNo(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject[0].personDetail == null) {
          this.toaster.error(noVehicleFound);
          this.spinner.hide();
        }
        else {
          let name; let address; let phone; let vehicle;
          if (response.responseObject[0].vehicles?.length > 0) {
            vehicle = response.responseObject[0].vehicles[0];
          }
          if (response.responseObject[0].names?.length > 0) {
            for (let i = 0; i < response.responseObject[0].names.length; i++) {
              if (response.responseObject[0].names[i].sources != null || response.responseObject[0].names[i].sources != undefined) {
                for (const source of response.responseObject[0].names[i].sources) {
                  if (source.name === "DSF") {
                    name = response.responseObject[0].names[i];
                    phone = response.responseObject[0].phones[i];
                    if (response.responseObject[0].addresses.length > 0) {
                      address = response.responseObject[0].addresses[i];
                    }
                  }
                }
                if (name == undefined && response.responseObject[0].names.length > 0) {
                  name = response.responseObject[0].names[0];
                }
                if (phone == undefined && response.responseObject[0].phones.length > 0) {
                  phone = response.responseObject[0].phones[0];
                }
                if (address == undefined && response.responseObject[0].addresses.length > 0) {
                  address = response.responseObject[0].addresses[0];
                }
              }
            }
          }
          let model = this.CreateDFModel(name, address, phone, vehicle);
          this.AddDFDetails(model);
          this.spinner.hide();
        }
      }
    });
  }
  async AddDFDetails(model: DFModel) {
    await this.service.AddDFDetails(model)
      .then((response) => {
        if (response.result?.isUpdated) {
          this.getWidgetAppointmentDetail(this.appointmentDetails.id);
          let DFDetailsFetched = this.translate.instant("lblDFDetailsFetchedSuccessfully");
          this.toaster.success(DFDetailsFetched);
        }
        else {
          let DFDetailsNotFetched = this.translate.instant("lblDFDetailsNotFetched");
          this.toaster.success(DFDetailsNotFetched);
        }
        this.isDFCopyToDisable = true;
      });
  }
  CreateDFModel(name, address, phone, vehicle): DFModel {
    return {
      WidgetAppointmentRequestId: this.appointmentDetails.id,
      DFFirstName: name?.firstName,
      DFLastName: name?.lastName,
      DFCustName: name?.fullName,
      DFAddressLine_1: address?.address,
      DFAddressLine_2: null,
      DFCity: address?.city,
      DFState: null,
      DFCountry: null,
      DFCountryId: null,
      DFPincode: address?.postalCode,
      DFCustEmailId: null,
      DFCustMobileNo: phone?.number,
      DFDialCode: phone?.country,
      DFEngineSerialNo: null,
      DFCompanyModel: vehicle?.modelName,
      DFCompanyMakeName: vehicle?.brandName,
      DFRegistrationDate: vehicle?.firstRegistrationDate,
      DFColor: vehicle?.colorText,
      DFYear: vehicle?.modelYear,
      DFChassisNo: vehicle?.vehicleIdentificationNumber,
      DFFuelType: vehicle?.fuelTypeText,
      DFVehicleType: vehicle?.vehicleGroup,
      DFComplianceNumber: vehicle?.complianceNumber,
      DFRegistrationLastDate: vehicle?.lastRegistrationDate,
      DFTransmission: vehicle?.transmission,
      DFTotalWeight: vehicle?.totalWeight,
      DFCurbWeight: vehicle?.curbWeight,
      DFNumberOfAxles: vehicle?.noOfAxles,
      DFAxleWeightLimit_Front: vehicle?.axleWeightLimit_Front,
      DFAxleWeightLimit_Rear: vehicle?.axleWeightLimit_Rear,
      DFTyreDimension_Front: vehicle?.tyreDimension_Front,
      DFTyreDimension_Rear: vehicle?.tyreDimension_Rear,
      DFTyreLoadIndex_Front: vehicle?.tyreLoadIndex_Front,
      DFTyreLoadIndex_Rear: vehicle?.tyreLoadIndex_Rear,
      DFTyreSpeedIndex_Front: vehicle?.tyreSpeedIndex_Front,
      DFTyreSpeedIndex_Rear: vehicle?.tyreSpeedIndex_Rear,
      DFInspectionNextDate: vehicle?.nextInspectionDate,
      DFInspectionPrevDate: vehicle?.previousInspectionDate,
      DFOwnerType: vehicle?.ownerType,
    }
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onInputChange(event: any) {
    this.widgetData[0].email = event.target.value;
  }
  createModalForApproveReject(isApprove: boolean) {

    this.approverejectModal.widgetAppointmentId = this.appointmentDetails.id;
    this.approverejectModal.isApprove = isApprove;
    this.approverejectModal.existingVehicleId =
    this.widgetAppointmentDetails.existingVehicleId;
    this.approverejectModal.vin=this.widgetAppointmentDetails.vehicle_ChassisNo;
    this.approverejectModal.customerID = this.widgetData[0].customerId;
    this.approverejectModal.customerNumber = this.widgetData[0].customerNo;
    this.approverejectModal.customerEmail = this.widgetData[0].email;
    this.approverejectModal.licensePlate=this.appointmentDetails.licensePlate;
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        let feature = this.features.find((x) => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.approverejectModal.integrationWithDMS = feature;
        let featureGenerate = this.features.find((x) => x.featureCode === Enums.FeatureCode.GWoNoPlannerSide)?.isActive;
        this.approverejectModal.generateWorkOrderNoPlannerSide = featureGenerate;
        let realTimeVehicle = this.features.find((x) => x.featureCode === Enums.FeatureCode.RTDSV)?.isActive;
        this.approverejectModal.realtimeDmsSyncVehicle = realTimeVehicle;
        let realTimeAppointment = this.features.find((x) => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
        this.approverejectModal.realtimeDmsSyncAppointment = realTimeAppointment;
        let realTimeApproveWarAppointment = this.features.find((x) => x.featureCode === Enums.FeatureCode.RTWRA)?.isActive;
        this.approverejectModal.realtimeDmsSyncWidgetAppointmentRequest = realTimeApproveWarAppointment;
      }
    }

    this.approverejectModal.moduleId = Enums.ModuleNames.Vehicle;
    this.approverejectModal.appointmentModuleId = Enums.ModuleNames.Appointment;
    let language = this.cookieservice.get('userSelectedLanguage');
    this.approverejectModal.languageCode = language;
    this.approverejectModal.appointmentType = "Order";
    this.approverejectModal.ownerTypeId = "";
    this.approverejectModal.ownerType = "";
    this.selectedOwnerType.forEach(element => {
      this.approverejectModal.ownerTypeId+= element.value + ',';
      this.approverejectModal.ownerType+=element.text +',';
    });
    this.approverejectModal.ownerTypeId=this.approverejectModal.ownerTypeId.trim().slice(0, -1);
    this.approverejectModal.ownerType=this.approverejectModal.ownerType.trim().slice(0, -1);
  }

  async onApproveReject(isApprove: boolean) {
    if (isApprove && this.customerDriver.customerNo != this.widgetData[0].customerNo && this.customerOwner.customerNo != this.widgetData[0].customerNo && this.customerPayer.customerNo != this.widgetData[0].customerNo && this.customerUser.customerNo != this.widgetData[0].customerNo) {
      let ErrorMsg = this.translate.instant('lblAssociationError');
      this.toaster.error(ErrorMsg);
      return;
    }

    this.createModalForApproveReject(isApprove);
    if(isApprove){
      if(this.approverejectModal.ownerTypeId == "7"){
        let invalidPayer = this.translate.instant('lblInvalidPayer');
        this.toaster.error(invalidPayer);
        return;
      }
    }
    this.spinner.show();
    await this.service
      .approveRejectWidgetAppointment(this.approverejectModal)
      .then((response) => {
        let ErrorMsg = '';
        if (response.responseObject?.result?.isRejected) {
          ErrorMsg = this.translate.instant('lblRejectedSuccess');
          this.toaster.success(ErrorMsg);
          this.OnClose();
          return;
        }
        if(this.approverejectModal.realtimeDmsSyncWidgetAppointmentRequest){
          ErrorMsg = this.translate.instant('lblApprovedSuccess');
        }else{
          ErrorMsg = this.translate.instant('lblApprovedUnderProcess');
        }

        if (response.responseObject?.responseObject > 0) {
          this.toaster.success(ErrorMsg);
          this.OnClose();
          setTimeout(()=>{
              this.router.navigate(['/appointment']);
              this.editAppointment(response.responseObject?.responseObject);
          },250)
         
          return;
        }
        switch (response.result.errorCode) {
          case Enums.ErrorCodes.AddAppointMentError:
            ErrorMsg = this.translate.instant('lblCopyError');
            this.toaster.error(ErrorMsg);
            return;
          case Enums.ErrorCodes.CustomerVehicleNotFound:
            ErrorMsg = this.translate.instant(
              'lblWidgetCustomerVehicleNotFound'
            );
            this.toaster.error(ErrorMsg);
            return;
          case Enums.ErrorCodes.CustomerMappingError:
            ErrorMsg = this.translate.instant('lblCustomerVehicleNotMapped');
            this.toaster.error(ErrorMsg);
            return;
          default:
            break;
        }
      }).finally(()=>{
        this.spinner.hide();

      });

  }
  async editAppointment(appointment:any)
  {
    this.multiStackPopupService.OpenAppointment(appointment);
  }

  async viewAppointment(appointment:any)
  {
    this.multiStackPopupService.OpenAppointment(appointment, false, false,0,true);
  }
  OnClose() {
    this.activeModal.close({ success: true });
  }

  OpenCustomerValidation(customerDetails: any, isWidgetData: boolean): void {
    if(customerDetails.cust_ContactNo == null){
      this.toaster.error(this.translate.instant('lblProvideValidMobileNumber'));
      return;
    }
    const modalref = this.modalService.open(CustomerValidationComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });

    modalref.componentInstance.customerDetails = customerDetails;
    modalref.componentInstance.fromWidget = isWidgetData;
    modalref.componentInstance.preferredDealerId = this.appointmentDetails.dealerId;

    modalref.result.then(
      (response) => {
        if (response.success) {
          if (isWidgetData) {
            this.widgetData[0].customerId = response.customer.id;
            this.validatedWidgetCustomerDetails = response.customer;
            if (
              response.customer.customerNo === null ||
              response.customer.customerNo === ''
            ) {
              this.isWidgetCopyToDisable = true;
            } else {
              this.widgetData[0].customerNo = response.customer.customerNo;
              this.isWidgetCopyToDisable = false;
            }
          } else {
            this.dataFactoryData[0].customerId = response.customer.id;
            this.validatedDFCustomerDetails = response.customer;
            if (
              response.customer.customerNo === null ||
              response.customer.customerNo === ''
            ) {
              this.isDFCopyToDisable = true;
            } else {
              this.dataFactoryData[0].customerNo = response.customer.customerNo;
              this.isDFCopyToDisable = false;
            }
          }
        }
      }
    );
  }

  copyLicencePlateNo() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.licensePlate)
  }
  copyTextWoNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.widgetAppointmentNo)
  }
  
  mobileNumberChanged(){
    this.widgetData[0].cust_ContactNo = this.widgetData[0].cust_ContactNo?.number ? this.widgetData[0].cust_ContactNo.number.toString().replace(/\s+/g, '') : this.widgetData[0].cust_ContactNo;
  }

  onNomineeCountryChange(obj) {
    if (this.isInitialLoad) {
      this.telNomineeInputObject();
      this.widgetData[0].cust_ContactNo.dialCode = this.widgetData[0].cust_ContactNo.dialCode || obj.dialCode;
    } else {
      this.widgetData[0].cust_ContactNo.dialCode = obj.dialCode;
    }
  }

  telNomineeInputObject() {
    if (this.widgetData[0].cust_ContactNo.dialCode) {
      let countryCode = this.getCountryCodeByDialCode(this.widgetData[0].cust_ContactNo.dialCode.toString());
      this.selectedCountryISO = countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      this.selectedCountryISO = this.cultureLocaleService.getLocale();
      this.deafultDialCode = this.getDialCodeByCountryCode(this.selectedCountryISO);
    }
  }

  getDialCodeByCountryCode(countryCode) {
    const country = this.countryDialCodes.find(c => c.countryCode === countryCode);
    return country ? country.dialCode : null;
  }

  getCountryCodeByDialCode(dialCode: any) {
    if(dialCode[0]==="+")
    {
      dialCode = dialCode.slice(1);
    }
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }
}
